import { APP_INITIALIZER, ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authConfig } from './services/auth-config';
import { provideAuth } from 'angular-auth-oidc-client';
import { authHeaderInterceptor } from './core/interceptors/auth-header.interceptor';
import { AdScriptLoaderService } from './services/ad-script-loader.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withInterceptors([authHeaderInterceptor])),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideAuth(authConfig),
    {
      provide: APP_INITIALIZER,
      useFactory: (svc: AdScriptLoaderService) => () => svc.load(),
      deps: [AdScriptLoaderService],
      multi: true,
    },
  ]
};
